import { render, staticRenderFns } from "./nature2_1.vue?vue&type=template&id=47f5f9fa&scoped=true&"
import script from "./nature2_1.vue?vue&type=script&lang=js&"
export * from "./nature2_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5f9fa",
  null
  
)

export default component.exports